import React, { useEffect, useState } from "react";
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

function CookieConsent() {
  const [show, setShow] = useState(true);

  if (show) {
    return (
      <Alert onClose={() => setShow(false)} className="w-100 rounded-0 mb-0 position-absolute bottom-0 start-50 translate-middle-x glass-alert py-lg-3 px-lg-5" style={{ zIndex:3}} dismissible>
        
        <p>This website uses cookies</p>
        <p className="text-small">
        We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.
        </p>
      </Alert>
    );
  }
}

export default CookieConsent;